import Vue from 'Vue';
import _ from 'lodash';

/**
 * ********************************************************************
 * standard import lines for every component. Importing the template
 * and the component specific style.
 * ********************************************************************
 */
import './dc-popup.style.scss';
import template from './dc-popup.template.htm';
/**
 * *********************************************************************
 */

/**
 * item structure:
 * {
 *     image: string,
 *     title: string,
 *     subtitle: string,
 *     link: string,
 *     tripActive: boolean
 * }
 */

export default Vue.component('dc-popup', {
    template: template,
    props: ['item', 'className'],
    data() {
        return {

        };
    },
    computed: {

    },
    created() {},
    mounted() {},
    methods: {
        hasImage(){
            return _.get(this.item, 'image', '') !== '';
        },
        getImage(returnRaw){
            let thumbnail = _.get(this.item, 'image', '');
            if(!thumbnail)
                return '';
            return returnRaw ? thumbnail : {'background-image':`url("${thumbnail}")`};
        },
        onDetailsClick(){
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'user action',
                'gaEventCategory': 'karte angebot click details',		// keine VAR, ist fest vergeben
                'gaEventAction': _.get(this.item, 'title', ''),  					            // VAR =  Titel <- "TT 5: DONAU-RADWEG VON HOF ZU HOF: BEI BEHERZTEN LANDLEUTEN EINKEHREN"
                'gaEventValue': '1',						            // Fest =  1
            });
        }
    },
    watch: {}
});